// @flow
import numeral from 'numeral';
import { stylesheet } from 'typestyle';

import LinkPopup from '@components/popups/Link';
import * as BankWireContent from '@components/popups/content/BankWire';

import PromoDescription from '@components/productDetail/PromoDescription';

import {
  headerBlueText,
  regularYellowText,
  lightGrayText,
  paragraphFontFamilies
} from '@src/styles/general';

type PropsType = {
  title: string,
  price: number,
  bank_wire: number,
  noCapitalize?: boolean,
  isPromoSetting: boolean
};

type StateType = {
  showPopup: boolean
};

const questionMark = '/images/question_mark_with_circle.svg';

const currencyFormat = '$0,0';

const css = stylesheet({
  container: {
    marginTop: 6,
    position: 'relative',

    '@media (max-width: 679px)': {
      marginTop: 40
    },

    $nest: {
      '.product-detail--container.diamond &': {
        '@media (max-width: 679px)': {
          marginTop: 0
        }
      },

      '.product-detail--container.engagement-ring &': {
        marginBottom: 20,

        '@media (max-width: 679px)': {
          marginTop: 0
        },

        // When we have two columns, make sure the image and description section are
        // the same height as much as possible
        '@media (min-width: 680px) and (max-width: 820px)': {
          minHeight: 131
        },

        // When we have three columns, make sure the image and description section are
        // the same height as much as possible
        '@media (min-width: 821px)': {
          minHeight: 174
        }
      },

      '.product-detail--container.band &': {
        marginBottom: 20,

        '@media (max-width: 679px)': {
          marginTop: 0
        },

        // When we have two columns, make sure the image and description section are
        // the same height as much as possible
        '@media (min-width: 680px)': {
          minHeight: 129
        }
      },

      '.product-detail--container.combo-ring &': {
        marginBottom: 20,

        '@media (max-width: 679px)': {
          marginTop: 0
        },

        // When we have two columns, make sure the image and description section are
        // the same height as much as possible
        '@media (min-width: 680px) and (max-width: 820px)': {
          minHeight: 131
        },

        // When we have three columns, make sure the image and description section are
        // the same height as much as possible
        '@media (min-width: 821px)': {
          minHeight: 146
        }
      }
    }
  },
  header: {
    fontWeight: 600,
    fontSize: 20,
    lineHeight: '28px',
    textTransform: 'capitalize',
    color: headerBlueText
  },
  price: {
    fontSize: 25,
    lineHeight: '28px',
    marginTop: -6,
    marginBottom: 2,
    color: regularYellowText,
    fontFamily: 'Georgia'
  },
  bankWire: {
    display: 'inline-block',
    fontFamily: paragraphFontFamilies,
    marginLeft: 10
  },
  bankWirePrice: {
    fontSize: 14,
    lineHeight: '21px',
    color: lightGrayText
  },
  bankWirePriceLink: {
    fontSize: 14,
    lineHeight: '21px',
    color: '#21528d',
    textDecoration: 'none',

    $nest: {
      '&:hover': {
        color: '#0078a0',
        textDecoration: 'underline'
      }
    }
  },
  bankWireQuestionMark: {
    width: 14
  }
});

export default class ItemHeader extends React.Component<PropsType, StateType> {
  popupAnchorRef: void | React.ElementRef<'a'>;

  state = {
    showPopup: false
  };

  togglePopup = (e: SyntheticMouseEvent<HTMLLinkElement>) => {
    e.preventDefault();

    this.setState(prevState => {
      return {
        showPopup: !prevState.showPopup
      };
    });
  };

  closePopup = () => {
    this.setState({
      showPopup: false
    });
  };

  render() {
    return (
      <div className={css.container}>
        <h1
          className={css.header}
          style={{
            textTransform: this.props.noCapitalize ? 'none' : 'capitalize'
          }}
        >
          {this.props.title}
        </h1>
        <div className={css.price}>
          {numeral(this.props.price).format(currencyFormat)}

          <div className={css.bankWire}>
            <span className={css.bankWirePrice}>
              {numeral(this.props.bank_wire).format(currencyFormat)}{' '}
            </span>
            <LinkPopup initialContent={BankWireContent} className=''>
              <span className={css.bankWirePriceLink}>via bank wire</span>{' '}
              <img src={questionMark} className={css.bankWireQuestionMark} />
            </LinkPopup>
          </div>
        </div>
        {this.props.isPromoSetting ? <PromoDescription /> : null}
      </div>
    );
  }
}
